/**
 * Created by mac on 12/23/20
 */

const Grounded = function (unit) {
    UnitComponent.call(this, unit); 
};

Grounded.prototype = Object.create(UnitComponent.prototype);
Grounded.prototype.constructor = Grounded;

Grounded.prototype.isMovable = function () {
    return false;
};

Grounded.prototype.remove = function (silent) {
    if (this.view) {
        this.view.onRemove(silent);
    }
};

Grounded.prototype.save = function (data) {
    data.grounded = 1;
};

Grounded.prototype.onHighlight = function () {
    if (this.view) {
        this.view.highlight();
    }
};

Grounded.prototype.onUnhighlight = function () {
    if (this.view) {
        this.view.unhighlight();
    }
};

Grounded.prototype.canSmile = function () {
    if (this.view) {
        return this.view.canSmile();
    }
};

Grounded.prototype.smile = function () {
    if (this.view) {
        this.view.smile();
    }
};
